import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import LoaderButton from '../LoaderButton/LoaderButton';
import { createUseStyles } from 'react-jss';
import renderBetsInput from './BetsInput/BetsInput';
import NoBetsBadge from './NoBetsBadge';
import BetsBadge from './BetsBadge';
import YourBetBadge from './YourBetBadge';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import { compose } from 'redux';

const MIN_BET_RISE = 50;
let validationProps = {};
let betToLowFormValidate = true;

const AuctionForm = (props) => {
  const { handleSubmit, inputBetValue, change, mobileSearchUrl,
          highestBetValue, dealerBetHighest, errorBetsDetails, touch, t, } = props;

  if (errorBetsDetails) {
    // runs from validation
    if (betToLowFormValidate) {
      touch('value');
      change('value', '1');
      change('value', '');
      betToLowFormValidate = false;
    }
  }
  const BadgeComponent = () => {
    if (dealerBetHighest) {
      return (
        <YourBetBadge t={t} highestBetValue={highestBetValue} />
      );
    }
    if (highestBetValue === 0) {
      return (
        <NoBetsBadge t={t} />
      );
    }
    return <BetsBadge t={t} highestBetValue={highestBetValue} />;
  };

  const classes = useStyles();
  validationProps = { t, highestBetValue, };

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="value"
        component={renderBetsInput}
        label={t('your_offer')}
        type="number"
      />
      <BadgeComponent />
      <LoaderButton
        type="button"
        label={t('check_price')}
        className={classes.button}
        onClick={(e) => {
          e.preventDefault();
          window.open(mobileSearchUrl, '_blank').focus();
        }}
      />
      <LoaderButton
        label={t('send_offer')}
        className={classes.button}
        disabled={inputBetValue === ''}
      />
    </form>
    );
};

AuctionForm.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  mobileSearchUrl: PropTypes.string,
  inputBetValue: PropTypes.string,
  highestBetValue: PropTypes.number,
  dealerBetHighest: PropTypes.bool,
  errorBetsDetails: PropTypes.bool,
  change: PropTypes.func.isRequired,
  touch: PropTypes.func.isRequired,
};

AuctionForm.defaultProps = {
  dealerBet: 50,
  isDealerBetHighest: null,
  validSubmit: true,
  inputBetValue: '',
  highestBetValue: 0,
  dealerBetHighest: false,
  errorBetsDetails: false,
  mobileSearchUrl: '',
};

const useStyles = createUseStyles({
  button: {
    width: '100%',
    height: '60px',
    marginTop: '12px',
  },
});

const selector = formValueSelector('auctionForm');


const mapStateToProps = (state) => {
  const inputBetValue = selector(state, 'value');
  return {
    mobileSearchUrl: get(state, ['offerDetails', 'data', 'mobile_search_url']),
    inputBetValue,
  };
};


const validate = (values) => {
  const { t, highestBetValue, } = validationProps;
  const priceToLow = t ? t('price_to_low') : 'price to low';
  const errorMessage = `${priceToLow} ${highestBetValue + MIN_BET_RISE} €`;
  const value = parseInt(get(values, 'value'), 10) ? parseInt(get(values, 'value'), 10) : 0;
  const errors = {
    value: value < highestBetValue + MIN_BET_RISE && errorMessage,
  };
  return errors;
};

export default compose(connect(mapStateToProps), withScopedTranslations('dealers_offers'), reduxForm({
  form: 'auctionForm',
  validate,
}))(AuctionForm);

